import { Component, Prop, State, h, Host, Event, EventEmitter } from '@stencil/core';

@Component({
  tag: 'dda-tabs',
  styleUrls: ['dda-tabs.css'],
  shadow: false,
})
export class DdaTabs {
  @Prop() type: 'text' | 'text-icon' = 'text';
  @Prop() hover_style: 'dda-tab-default' | 'dda-tab-filed' | 'dda-tab-underline' | 'dda-tab-underline-filled' = 'dda-tab-default';
  @Prop() border_bottom: boolean = false;
  @Prop() custom_class?: string = '';
  @Prop() component_mode?: string;
  @Prop() button_ids: string = '["tab-btn-1", "tab-btn-2", "tab-btn-3"]'; // New prop for dynamic button IDs
  @Prop() tab_value: string;
  @Prop() tab_texts: string = '["Tab 1", "Tab 2", "Tab 3"]'; // Keep it as a string
  @Prop() tab_icons: string = '["sentiment_satisfied", "sentiment_satisfied", "sentiment_satisfied"]';
  @Prop() button_name: string;
  @Prop() tab_type: 'dda-horizontal-tab' | 'dda-vertical-tab' = 'dda-horizontal-tab';
  @Event() tabClick: EventEmitter<number>;

  @Prop() button_values: string = '["", "", ""]';

  // private tabhandler = (index) => {
  //   this.tabClick.emit(index);
  // };

  @State() active_tab: number = 0;

  get parsedButtonValues() {
    try {
      return JSON.parse(this.button_values);
    } catch (error) {
      console.error('Error parsing button_values:', error);
      return ['', '', ''];
    }
  }

  get parsedTabs() {
    try {
      return JSON.parse(this.tab_texts); // Parse the string into an array
    } catch (error) {
      console.error('Error parsing tab_texts:', error);
      return ['Tab 1', 'Tab 2', 'Tab 3']; // Fallback to default
    }
  }

  get parsedIcons() {
    try {
      return JSON.parse(this.tab_icons); // Parse the string into an array
    } catch (error) {
      console.error('Error parsing tabicons:', error);
      return ['sentiment_satisfied', 'sentiment_satisfied', 'sentiment_satisfied']; // Fallback to default
    }
  }

  get parsedButtonIds() {
    try {
      return JSON.parse(this.button_ids);
    } catch (error) {
      console.error('Error parsing button_ids:', error);
      return ['tab-btn-1', 'tab-btn-2', 'tab-btn-3'];
    }
  }

  // setActiveTab(index: number) {
  //   this.active_tab = index;
  //   if (this.tabClick) {
  //     this.tabhandler(index);
  //   }
  // }
  setActiveTab(index: number) {
    this.active_tab = index;
    this.tabClick.emit(index);
  }

  render() {
    return (
      <Host>
        <div role="tablist" aria-label="Tab Navigation" class={`dda-tabs-container ${this.hover_style} ${this.custom_class} ${this.component_mode} ${this.tab_type}`}>
          {this.parsedTabs.map((title, index) => (
            <button
              id={this.parsedButtonIds[index] || `tab-btn-${index + 1}`}
              name={this.button_name}
              aria-label={title}
              type="button"
              value={this.parsedButtonValues[index] || ''}
              class={`dda-tab-item ${this.active_tab === index ? 'active' : ''}`}
              role="tab"
              aria-selected={this.active_tab === index ? 'true' : 'false'}
              aria-controls={`tab-btn-${index + 1}`}
              onClick={() => this.setActiveTab(index)}
            >
              {this.type === 'text-icon' && (
                <i class={`material-icons`} aria-hidden="true">
                  {this.parsedIcons[index] || ''}
                </i>
              )}
              <span>{title}</span>
            </button>
          ))}
        </div>
      </Host>
    );
  }
}
